<app-confirm-dialog
   [visible]="!!confirmationMessage"
   variant="secondary"
   heading="Confirmation"
   [message]="confirmationMessage"
   cancelText="No"
   (confirmed)="confirmPendingAction()"
   (cancelled)="cancelPendingAction()">
</app-confirm-dialog>

<div class="sales-Orders-responsive p-g-12">
   <div class="p-g-12 p-table-tecfolk-fix">
      <!-- <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">
         <p-tabPanel header="POS" leftIcon="fa fa-check"> -->
      <div class="p-g">
         <div class="p-g-12">
            <p-table [value]="sales" [rowHover]="true" [paginator]="true" [rows]="100" [responsive]="true"
               [loading]="loading" [first]="first" (onPage)="onPageChange($event)">
               <ng-template pTemplate="caption" style="text-align: left">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByInvoiceNumberLabel")}}</span>
                           <input id="searchOrder" #searchOrder autocomplete="off" pinputtext=""
                              (keyup)="searchLocal(saleOrder.invoiceNumber, 'number')"
                              [(ngModel)]="saleOrder.invoiceNumber"
                              [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                          <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                                <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" >
                                </p-calendar>
                            </div>

                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                                <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" >
                                </p-calendar>
                            </div>
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("paymentFilterLabel")}}</span>
                                <p-dropdown class="p-inputtext" [options]="paymentFilterOptions"
                                    [(ngModel)]="selectedPaymentFilter" (onChange)="onPaymentFilterChange()">
                                </p-dropdown>
                            </div>
                            <div *ngIf="this.user.role === 'Admin'" class="filterFields">
                                <span class="fieldTitle">{{setLabel("selectCategoryLabel")}}</span>
                                <p-dropdown class="p-inputtext" [options]="categoryOptions"
                                    [(ngModel)]="selectedCategoryOption" (onChange)="dropdownChange()">
                                </p-dropdown>
                            </div>
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("selectProductLabel")}}</span>
                                <p-dropdown class="p-inputtext" [options]="productOptions"
                                    [(ngModel)]="selectedProductOption" (onChange)="dropdownChange()"
                                    [filter]="true">
                                </p-dropdown>
                            </div>
                        <div class="reportMainBtn">
                            <div class="reportActions">
                            <app-action-button
                                variant="secondary"
                                size="sm"
                                text="Search"
                                icon="fa fa-search"
                                title="Search"
                                ariaLabel="Search"
                                [disabled]="loading"
                                (action)="getSales()">
                            </app-action-button>
                            <app-action-button
                                variant="secondary"
                                size="sm"
                                text="Clear"
                                icon="fa fa-eraser"
                                title="Clear"
                                ariaLabel="Clear"
                                [disabled]="loading"
                                (action)="clear()">
                            </app-action-button>
                            <app-action-button
                                variant="secondary"
                                size="sm"
                                text="Add New"
                                icon="pi pi-user-plus"
                                title="Add New"
                                ariaLabel="Add New"
                                routerLink="/point-of-sale"
                                [disabled]="loading">
                            </app-action-button>
                            </div>
                            <div class="reportTools">
                                <span [pTooltip]='setLabel("printTooltipLabel")' tooltipPosition="top" [disabled]="loading" [disabled]="!isData"
                                    (click)="printAllInvoice()"><i class="fa fa-print"></i></span>
                            </div>
                        </div>
                     </div>
                  </div>
               </ng-template>
               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("invoiceNumberLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("invoiceDateLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("soldToLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("productNameLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("subTotalLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("discountLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("totalTaxLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("grandTotalLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("cashPaidLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("remainingBalanceLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("cashReturnedLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("categoryLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("actionLabel")}}</th>
                  </tr>
               </ng-template>
               <ng-template pTemplate="body" let-rowData>
                  <tr class="p-selectable-row" >
                     <td >
                        <div class="mobile-Lable">{{setLabel("invoiceNumberLabel")}}</div>

                        {{rowData.invoiceNumber}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("invoiceDateLabel")}}</div>

                        {{rowData.invoiceDate | date: 'd/M/yy, h:mm a'}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("soldToLabel")}}</div>
                        <div>
                           <div>{{rowData.soldTo?.name}}</div>
                           <div *ngIf="getSoldToPhone(rowData)" class="sold-to-number">
                              {{ setLabel("phoneLabel") }}: {{ getSoldToPhone(rowData) }}
                           </div>
                        </div>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("productNameLabel")}}</div>
                        <div *ngFor="let product of rowData.products">
                           {{product.name}}
                        </div>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("subTotalLabel")}}</div>

                        {{rowData.subTotal | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("discountLabel")}}</div>

                        {{rowData.discount | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("totalTaxLabel")}}</div>

                        {{rowData.vatTax | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("grandTotalLabel")}}</div>

                        {{rowData.total | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("cashPaidLabel")}}</div>

                        {{rowData.paid | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("remainingBalanceLabel")}}</div>

                        {{ getRemainingBalance(rowData) | number:'1.0-0' }}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("cashReturnedLabel")}}</div>

                        {{rowData.returned | number:'1.0-0'}}
                     </td>
                        <td>
                            <div class="mobile-Lable"> {{setLabel("categoryLabel")}}</div>
                            {{rowData.category }}
                        </td>
                        <td class="action-cell">
                            <span class="mobile-Lable"> {{setLabel("actionLabel")}}</span>
                            <button *ngIf="user.role === 'Admin'"  pButton type="button" tooltipPosition="top" pTooltip="Delete Product"
                                class="p-button-danger p-button" icon="fa fa-times" (click)="deleteOrder(rowData)">
                            </button>
                            <button  pButton type="button" tooltipPosition="top" pTooltip="View Order Details" icon="fa fa-pencil-square-o"
                                (click)="viewSaleOrder(rowData)">
                            </button>
                    </td>
                  </tr>
               </ng-template>
               <ng-template pTemplate="footer">
                  <tr><td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td style="font-size: 16px; font-weight: bold; text-align: center; border: 1px solid #ababab;" colspan="2">
                        {{setLabel("summaryLabel")}}
                     </td>
                  </tr>
                  <tr><td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td style="font-size: 16px; text-align: right; border: 1px solid #ababab; text-align: start;" colspan="1">
                        {{setLabel("totalCountLabel")}}
                     </td>
                     <td colspan="1" style="font-size: 16px; text-align: end; border: 1px solid #ababab;">
                        {{sales?.length}}
                     </td>
                  </tr>
                  <tr>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td colspan="1" style="border: 1px solid gray;">
                        {{setLabel("totalSalesLabel")}}
                     </td>
                     <td colspan="1" style="font-size: 16px; text-align: end; border: 1px solid #ababab;">
                       {{getTotalSales() | number:'1.0-0'}}
                     </td>
                  </tr>
               </ng-template>
               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>

            </p-table>
         </div>
      </div>
      <!-- </p-tabPanel> -->
      <!-- <p-tabPanel header="Delivery Sale Orders" leftIcon="fa fa-check">
            <div class="p-g">
               <div class="p-g-12">
                  <p-table [value]="deliverySales" [rowHover]="true" [paginator]="true" [rows]="10" [responsive]="true" [loading]="loading" [first]="first" (onPage)="onPageChange($event)">
                     <ng-template pTemplate="caption" style="text-align: left">
                        <input id="searchOrder" #searchOrder style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px; width: 18%;"
                           autocomplete="off" pinputtext="" (keyup)="searchLocalDeliveryOrders(saleOrder.invoiceNumber, 'number')"
                           [(ngModel)]="saleOrder.invoiceNumber" placeholder="Search By Invoice Number" type="text" name="name"
                           class="ng-pristine ng-valid ng-touched">
                        <button style="background: #ffffff; color: #0e2031; margin-right: 8px;" (click)="clearSearchDeliveryOrders()"
                           class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                              class="fa fa-eraser"></i>&nbsp;Clear
                           Search
                        </button>
                        <button routerLink="/point-of-sale" style="background-color: #5192d0; margin-right: 8px;"
                           class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                           <i class="fa fa-plus"></i>&nbsp;
                           New
                           <span style="font-family: none;font-size: small;"> (F2)</span>
                        </button>
                     </ng-template>
                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">Invoice Number</th>
                           <th style="max-width: 90px;">Invoice Date</th>

                           <th style="max-width: 130px;">Grand-Total</th>
                           <th style="max-width: 130px;">Cash Paid</th>
                           <th style="max-width: 130px;">Cash Returned</th>
                           <th style="max-width: 90px;">Delivery Status</th>
                        </tr>
                     </ng-template>
                     <ng-template pTemplate="body" let-rowData>
                        <tr class="p-selectable-row" (click)="viewSaleOrder(rowData)">
                           <td style="padding-left: 3%;">{{rowData.invoiceNumber}}</td>
                           <td>{{rowData.invoiceDate | date: 'd/M/yy, h:mm a'}}</td>
                           <td>{{rowData.total}}</td>
                           <td>{{rowData.paid}}</td>
                           <td>{{rowData.returned}}</td>
                           <td>
                              {{rowData.status == 'REQUESTED' ? 'Requested'
                              :rowData.status == 'CONFIRMED' ? 'Confirmed'
                              :rowData.status == 'READY_TO_SHIPPED' ? 'Ready to Shipped'
                              :rowData.status == 'SHIPPED' ? 'Shipped'
                              :'Delivered'}}
                           </td>
                        </tr>
                     </ng-template>
                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                           <td>
                              No record found
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel> -->
      <!-- </p-tabView> -->
   </div>
</div>
<div id="allInvoice" #allInvoice style="display: none;">
    <div class="invoice-box">

        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;"><img
                        [src]=" (this.company.bannerImage ? config.Server + 'assets/layout/images/companies/' + this.company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(this.company.bannerImage ? config.Server + 'assets/layout/images/companies/' + this.company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%;"> </td>

                <td>
                    <div style="width: 438px;">{{branch.name}}</div>
                    <div style="width: 438px;">{{branch.address}}</div>
                    <div>
                        {{setLabel("phoneNo:Label")}} {{branch.phone}}
                    </div>
                    <div>
                        {{setLabel("created:Label")}} {{date | date: 'dd/MM/yyyy'}}
                    </div>
                </td>
            </tbody>
        </table>

        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceNoLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceDateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("soldToLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("productsLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("discountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("taxLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("saleAmountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("totalLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("cashPaidLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("remainingBalanceLabel")}}</td>
                            
                        </tr>
                        <tr class="item" *ngFor="let item of sales">
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceNumber}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceDate | date: 'medium'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                <div>{{item.soldTo?.name}}</div>
                                <div *ngIf="getSoldToPhone(item)" style="font-size: 10px; color: #555;">
                                    {{ setLabel("phoneLabel") }}: {{ getSoldToPhone(item) }}
                                </div>
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                <div *ngFor="let product of item.products" style="margin-bottom:3px;">
                                    <b>{{ product.name }}</b>
                                    ({{ product.quantity }} × {{ product.unitPrice | number:'1.0-0' }})
                                    = {{ product.quantity * product.unitPrice | number:'1.0-0' }}
                                </div>
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.discount | number:'1.0-0'}}  
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.vatTax | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.subTotal | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.total | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.paid | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{ getRemainingBalance(item) | number:'1.0-0' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>
        <table>
            <tbody>
                <tr>
                    <td>
                        <div class="logoDiv">
                            {{setLabel("poweredByLabel")}} &nbsp;
                            <a href="http://tecfolk.com/" target="_blank">
                                <img style="width:66px;"
                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="">
                            </a>
                        </div>
                    </td>
                    <!-- <td style="padding-top: 0;">
                        <table *ngIf="reportSummary != undefined"
                            style="border-collapse: collapse;position: relative;top: -5px; top: -3px; left: 7px;">
                            <tbody>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray; text-align: center; font-weight: bold; padding-left: 15px;"
                                        colspan="2">{{setLabel("summaryLabel")}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("totalSalesLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.Sale | number:'1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("totalDiscountLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.discount | number:'1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("totalTaxLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.Tax | number:'1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("grandTotalLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.total | number:'1.0-0'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td> -->
                </tr>
            </tbody>
        </table>


    </div>
</div><div id="allInvoice" #allInvoice style="display: none;">
    <div class="invoice-box">

        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;"><img
                        [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%;"> </td>

                <td>
                    <div style="width: 438px;">{{branch.name}}</div>
                    <div style="width: 438px;">{{branch.address}}</div>
                    <div>
                        {{setLabel("phoneNo:Label")}} {{branch.phone}}
                    </div>
                    <div>
                        {{setLabel("created:Label")}} {{date | date: 'dd/MM/yyyy'}}
                    </div>
                </td>
            </tbody>
        </table>

        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceNoLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceDateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("productsLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("discountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("taxLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("saleAmountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("totalLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("cashPaidLabel")}}</td>
                        </tr>
                        <tr class="item" *ngFor="let item of sales">
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceNumber}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceDate | date: 'medium'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                <!-- <div *ngFor="let product of item.products">
                                    {{ product.name }}
                                    <span class="pos-span" *ngIf="product.unitPrice != getProductNormalPrice(product) && product.ingredients.length> 0">
                                     {{setLabel("customLabel")}}
                                    </span>
                                    <span class="pos-span" *ngIf="product.unitPrice == getProductNormalPrice(product) && product.ingredients.length> 0">
                                      {{setLabel("standardLabel")}}
                                    </span>
                                </div> -->
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.discount | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.vatTax | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.subTotal | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.total | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.paid | number:'1.0-0'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>
        <table>
            <tbody>
                <tr>
                    <td>
                        <div class="logoDiv">
                            {{setLabel("poweredByLabel")}} &nbsp;
                            <a href="http://tecfolk.com/" target="_blank">
                                <img style="width:66px;"
                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="">
                            </a>
                        </div>
                    </td>
                    <!-- <td style="padding-top: 0;">
                        <table *ngIf="reportSummary != undefined"
                            style="border-collapse: collapse;position: relative;top: -5px; top: -3px; left: 7px;">
                            <tbody>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray; text-align: center; font-weight: bold; padding-left: 15px;"
                                        colspan="2">{{setLabel("summaryLabel")}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("totalSalesLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.Sale | number:'1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("totalDiscountLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.discount | number:'1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("totalTaxLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.Tax | number:'1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 230px;"></td>
                                    <td style="border: 1px solid gray;">{{setLabel("grandTotalLabel")}}</td>
                                    <td style="border: 1px solid gray;">{{reportSummary.total | number:'1.0-0'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td> -->
                </tr>
            </tbody>
        </table>


    </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
   <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>